import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { IMPLEMENTED_TRIGGERS } from "./triggers";

// Shows ONLY the triggers actually wired up (from ./triggers). As you implement more, they appear here.
const TriggerIntentModal = ({ open, onClose }) => {
  return (
    <Dialog maxWidth="lg" fullWidth open={open} onClose={onClose}>
      <DialogTitle sx={{ pr: 6 }}>
        Triggers / Intents
        <IconButton aria-label="close" onClick={onClose} sx={{ position: "absolute", right: 8, top: 8, color: "#64607a" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <p style={{ color: "#666", fontSize: 13, marginBottom: 12 }}>
          The triggers currently <b>implemented</b> (a firing point exists in the app). Pick one of these as the
          <b> Trigger</b> when creating an offer — others aren&apos;t wired up yet, so they wouldn&apos;t fire.
        </p>
        <TableContainer component={Paper}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "bold", minWidth: 180 }}>Intent</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Key</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Type</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Fires when</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Active until</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {IMPLEMENTED_TRIGGERS.map((t) => (
                <TableRow key={t.key} hover>
                  <TableCell style={{ fontWeight: 600 }}>{t.label}</TableCell>
                  <TableCell><span style={{ color: "#5B21B6", fontSize: 12, fontFamily: "monospace" }}>{t.key}</span></TableCell>
                  <TableCell style={{ fontSize: 13 }}>{t.type}</TableCell>
                  <TableCell style={{ fontSize: 13 }}>{t.fires}</TableCell>
                  <TableCell style={{ fontSize: 13, color: "#555" }}>{t.until}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TriggerIntentModal;
